/**
 * @license
 * @copyright Copyright Motili Inc., 2021 All Rights Reserved
 */

import { ReactElement } from 'react';
import 'react-dates/lib/css/_datepicker.css';
import { styled } from 'styled-components';
import { Paragraph } from '@motili/ui';

interface FileCardProps {
    fileName: string;
    handleTrashClick: () => void;
}

const shortenFileName = (text: string) => {
    if (text.length > 25) {
        return '...' + text.substr(text.length - 25, text.length);
    }
    return text;
};

export default function FileCard({
    fileName,
    handleTrashClick,
}: FileCardProps): ReactElement {
    return (
        <StyledFileContainer>
            <StyledFileContent>
                <Paragraph>{shortenFileName(fileName)}</Paragraph>
                <StyledTrashIcon
                    onClick={handleTrashClick}
                    className={`fa fa-trash`}
                />
            </StyledFileContent>
        </StyledFileContainer>
    );
}

const StyledTrashIcon = styled.i`
    font-size: ${({ theme }) => theme.fontSizes['22']};
    color: ${({ theme }) => theme.colors.red};
    cursor: pointer;
`;

const StyledFileContainer = styled.div`
    width: 90%;
    align-items: center;
    background-color: ${({ theme }) => theme.colors.green};
    padding: 20px;
    margin: 20px auto;
`;

const StyledFileContent = styled.div`
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: 100%;
    & > p {
        margin: 0;
        font-weight: bold;
        font-size: ${({ theme }) => theme.fontSizes['16']};
    }
`;
